import { GoogleGenerativeAI } from '@google/generative-ai';

import { GEMINI_API_KEY } from '../config/aiConfig';

const MODEL = 'gemini-2.0-flash';

function stripOptionalCodeFence(text: string): string {
  let s = text.trim();
  if (s.startsWith('```')) {
    s = s
      .replace(/^```(?:\w+)?\s*/i, '')
      .replace(/\s*```\s*$/i, '')
      .trim();
  }
  return s;
}

/**
 * Pazar yeri ilan açıklamasını samimi, güven verici bir tona çevirir (düz metin).
 */
export async function beautifyMarketplaceListingDescription(
  description: string,
): Promise<string> {
  if (!GEMINI_API_KEY || GEMINI_API_KEY === 'BURAYA_API_KEY_GELECEK') {
    throw new Error('GEMINI_API_KEY yapılandırılmadı. src/config/aiConfig.ts dosyasını doldurun.');
  }
  const trimmed = description.trim();
  if (!trimmed) {
    throw new Error('Açıklama boş olamaz.');
  }

  const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
  const model = genAI.getGenerativeModel({ model: MODEL });

  const prompt = `Bir samimi ebeveyn dili uzmanısın. Kullanıcının girdiği pazar yeri ilan açıklamasını, güven verici, samimi, sıcak ve 'ikinci elden devir' ruhunu yansıtan bir tona çevir. Orijinal metindeki temel bilgileri (temizlik, kullanım durumu vb.) koru ama daha hikayesel bir dil kullan. Yanıtı sadece güzelleştirilmiş metin olarak dön.

Kullanıcının metni:
---
${trimmed}
---`;

  const result = await model.generateContent(prompt);
  const raw = result.response.text();
  return stripOptionalCodeFence(raw);
}

/**
 * Dert köşesi: soru metni veya yorumu sıcak, destekleyici ve okunaklı hale getirir (düz metin).
 */
export async function beautifyForumText(
  text: string,
  kind: 'post' | 'comment',
): Promise<string> {
  if (!GEMINI_API_KEY || GEMINI_API_KEY === 'BURAYA_API_KEY_GELECEK') {
    throw new Error('GEMINI_API_KEY yapılandırılmadı. src/config/aiConfig.ts dosyasını doldurun.');
  }
  const trimmed = text.trim();
  if (!trimmed) {
    throw new Error('Metin boş olamaz.');
  }

  const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
  const model = genAI.getGenerativeModel({ model: MODEL });

  const roleHint =
    kind === 'post'
      ? 'Annedaş topluluğunda açılan yeni bir soru / dert metni.'
      : 'Bir gönderiye yazılan destekleyici yorum.';

  const prompt = `Sen samimi ve destekleyici bir ebeveyn topluluğu üyesisin. ${roleHint}
Metni aynı anlamı koruyarak daha sıcak, net ve okunaklı hale getir; abartılı vaatler veya tıbbi öneri ekleme. Türkçe yaz. Yanıtı sadece güzelleştirilmiş metin olarak dön.

Metin:
---
${trimmed}
---`;

  const result = await model.generateContent(prompt);
  const raw = result.response.text();
  return stripOptionalCodeFence(raw);
}
